module.exports = __webpack_public_path__ + "static/media/gommista_blue.b75972d1.png";